import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';

// 👇️ IMPORTANT: use correct ID of your root element
// this is the ID of the div in your index.html file
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  
    <App />
  ,
);





// 👇️ if you use TypeScript, add non-null (!) assertion operator
// const root = createRoot(rootElement!);

// import './index.css';
// import {StrictMode} from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';




// ReactDOM.render(
  
//     <App />
//   ,
//   document.getElementById('root')
// );



